import React from "react";
import Header from "./Header";
import StatsSection from "./StatsSection";
import StatsCard from "./StatsCard";
import QuotationTable from "./QuotationTable";
import { chartData, statsData, tableData } from "./data";
function Dashboard() {
  return (
    <div className="min-h-screen bg-gray-50">

      <div className="ml-72">
        <Header />

        <main className="p-6">
          {/* Stats Analysis Section */}
          <div className="mb-6 bg-white rounded-lg p-6">
            <div className="flex justify-between items-start mb-4">
              <h2 className="font-poppins font-medium text-3xl leading-none text-[#173363]">
                Stats Analysis
              </h2>
              <div>
                <select className="px-4 py-2 bg-white rounded-[1.25rem] border border-gray-300 text-lg text-[#8C89B4] cursor-pointer mr-2">
                  <option>Filter</option>
                  <option>2021</option>
                  <option>2022</option>
                </select>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-6">
              <div className="lg:w-3/4">
                <StatsSection data={chartData} />
              </div>
              <div className="lg:w-1/4 space-y-4">
                {statsData.map((stat) => (
                  <StatsCard key={stat.id} {...stat} />
                ))}
              </div>
            </div>
          </div>

          {/* Quotation Table Section */}
          <div className="">
            <div className="flex justify-between items-center mb-4">
              {/* <h2 className="font-poppins font-medium text-2xl leading-none text-[#173363]">
                Quotation Table
              </h2> */}
            </div>
            <QuotationTable data={tableData} />
          </div>
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
